export const colorTokens = {
  semantic: {
    epcRating: {
      A: { surface: '#0f7d58', border: '#0d4834' },
      B: { surface: '#41ad6c', border: '#247f48' },
      C: { surface: '#98c354', border: '#769b3a' },
      D: { surface: '#f7d12c', border: '#d1b022' },
      E: { surface: '#db9559', border: '#b4753f' },
      F: { surface: '#ef8c3b', border: '#c66f28' },
      G: { surface: '#d92d46', border: '#b6182f' },
    },
    brand: {
      base: {
        background: '#f7f5f5',
        white: '#ffffff',
        black: '#1d1b20',
      },
      primary: '#8e58ef',
      secondary: '#392360',
      tertiary: '#d7ecf1',
      red: '#f44336',
    },
    status: {
      success: '#6dcc67',
      warning: '#fdb022',
      error: '#f44336',
      successSoftEmphasis: {
        surface: '#f0f9f0',
        text: '#1d4d1a',
        icon: '#6dcc67',
        border: '#c2e6c2',
      },
      successHighEmphasis: {
        surface: '#6dcc67',
        text: '#ffffff',
        icon: '#ffffff',
        border: '#59b354',
      },
      warningHighEmphasis: {
        surface: '#fdb022',
        text: '#ffffff',
        icon: '#ffffff',
        border: '#e69a00',
      },
      warningSoftEmphasis: {
        surface: '#fff8eb',
        text: '#dc6803',
        icon: '#dc6803',
        border: '#fde0a3',
      },
      errorHighEmphasis: {
        surface: '#f44336',
        text: '#ffffff',
        icon: '#ffffff',
        border: '#d32f2f',
      },
      errorSoftEmphasis: {
        surface: '#fef3f2',
        text: '#912018',
        icon: '#912018',
        border: '#f9d1cf',
      },
    },
  },
  text: {
    title: '#1d1b20',
    bodyNeutral: '#1e2024',
    subtextNeutral: '#5a5e68',
    bodyAccent: '#413352',
    subtextAccent: '#7b659f',
    disabled: '#bfbfbf',
    icon: '#5a5555',
    linkText: '#8e58ef',
  },
  surface: {
    border: {
      /** Folder tab and dashboard panel borders (KDS). */
      subtle: '#ebf0f3',
    },
    interactive: {
      hover: '#f0f2f4',
      pressed: '#e8eaed',
    },
    /** Filter rule-builder row fill (Figma applied-filters-popover). */
    ruleRow: '#faf9fc',
  },
  global: {
    neutral: {
      100: '#e3e3e3',
      200: '#cccbcb',
      300: '#bfbfbf',
      400: '#9f9c9c',
      500: '#f5f5f5',
      600: '#898384',
      700: '#5a5555',
      800: '#433e3f',
      900: '#2b2829',
      1000: '#1d1b20',
    },
    brandMuted: {
      25: '#fffcf5',
      50: '#f3f1f6',
      100: '#e3e0e4',
      200: '#cec8d9',
      300: '#b2a8c4',
      400: '#9082aa',
      500: '#6a5b86',
      600: '#413852',
      700: '#2a2435',
      800: '#1d1924',
      900: '#18151e',
    },
    primary: {
      50: '#f4efff',
      100: '#e8defc',
      200: '#d2bcf9',
      300: '#bb9bf5',
      400: '#a579f2',
      500: '#8e58ef',
      600: '#6016e6',
      700: '#5213c3',
      800: '#430fa1',
      900: '#350c7e',
      1000: '#27095c',
    },
    secondary: {
      50: '#f6f4f9',
      100: '#edeafa',
      200: '#dcd5ef',
      300: '#c2b6e1',
      400: '#a392ce',
      500: '#392360',
      600: '#321f55',
      700: '#2b1b4a',
      800: '#24163e',
      900: '#1c1131',
      1000: '#110a1e',
    },
    other: {
      blue: {
        50: '#eef3ff',
        100: '#d6e2ff',
        200: '#afc6ff',
        300: '#7fa2ff',
        400: '#4d7bff',
        500: '#1e61f1',
        600: '#184fcc',
        700: '#123ea6',
        800: '#0c2d80',
        900: '#081e59',
      },
      yellow: {
        50: '#fff8e1',
        100: '#fff0b3',
        200: '#ffe680',
        300: '#ffdb4d',
        400: '#ffd11a',
        500: '#fbc400',
        600: '#d9a500',
        700: '#b78800',
        800: '#946b00',
        900: '#735100',
      },
      pink: {
        50: '#fef2fd',
        100: '#fde3fb',
        200: '#fbc6f7',
        300: '#f9a0ef',
        400: '#f57ae5',
        500: '#e84fd4',
        600: '#c82eb3',
        700: '#a12590',
        800: '#7b1d6e',
        900: '#521349',
      },
      green: {
        50: '#f4f8ea',
        100: '#e8f1d5',
        200: '#d1e3ab',
        300: '#bbd681',
        400: '#a7c958',
        500: '#94bd31',
        600: '#769727',
        700: '#59711d',
        800: '#3b4c14',
        900: '#1d260a',
      },
      teal: {
        50: '#e9f5f2',
        100: '#c8e6de',
        200: '#92cebd',
        300: '#5db59c',
        400: '#36a78c',
        500: '#259982',
        600: '#1e7d6a',
        700: '#186253',
        800: '#11463c',
        900: '#0a2b25',
      },
      purple: {
        50: '#f6f1ff',
        100: '#ece2ff',
        200: '#d9c5ff',
        300: '#c5a8ff',
        400: '#b38cff',
        500: '#a071ff',
        600: '#805ad5',
        700: '#6b4bc3',
        800: '#553c9a',
        900: '#3d2b6f',
      },
      deepPurple: {
        50: '#f2e9f7',
        100: '#e5d3ef',
        200: '#cba7df',
        300: '#b17bcf',
        400: '#974fbf',
        500: '#7e22ad',
        600: '#651b8a',
        700: '#4c1468',
        800: '#330d45',
        900: '#1a0723',
      },
      orange: {
        50: '#fef7ee',
        100: '#fce9d1',
        200: '#f8d3a3',
        300: '#f4bd75',
        400: '#e29447',
        500: '#cf6c18',
        600: '#a65613',
        700: '#7d410e',
        800: '#532b09',
        900: '#2a1605',
      },
      coral: {
        50: '#fff1f0',
        100: '#ffe2de',
        200: '#ffc5bc',
        300: '#fea99a',
        400: '#fd8f7b',
        500: '#fd765d',
        600: '#ca5e4a',
        700: '#984738',
        800: '#652f25',
        900: '#331813',
      },
      red: {
        50: '#fbecf1',
        100: '#f7d0db',
        200: '#eea1b7',
        300: '#e57293',
        400: '#dc3d6f',
        500: '#d6064b',
        600: '#ab053c',
        700: '#80042d',
        800: '#56021e',
        900: '#2b010f',
      },
      navy: {
        50: '#e7f0f5',
        100: '#cfe1eb',
        200: '#9fc3d7',
        300: '#6fa5c3',
        400: '#4086af',
        500: '#11679b',
        600: '#0e527c',
        700: '#0a3d5d',
        800: '#07293e',
        900: '#03151f',
      },
      cyan: {
        50: '#f0fafa',
        100: '#e1f5f6',
        200: '#c3ebf0',
        300: '#a5e2e8',
        400: '#87d9df',
        500: '#68d1d6',
        600: '#53a7ab',
        700: '#3e7d80',
        800: '#2a5456',
        900: '#152a2b',
      },
    },
  },
  buttonStates: {
    primary: {
      default: {
        surface: '#8e58ef',
        text: '#ffffff',
        icon: '#ffffff',
      },
      hover: {
        surface: '#7946d9',
        text: '#ffffff',
        icon: '#ffffff',
      },
      pressed: {
        surface: '#6234b9',
        text: '#ffffff',
        icon: '#ffffff',
      },
      disabled: {
        surface: '#e3e3e3',
        text: '#898384',
        icon: '#898384',
      },
    },
    secondary: {
      default: {
        surface: '#ffffff',
        text: '#5a5e68',
        icon: '#1e2024',
        border: '#bdbdbd',
      },
      hover: {
        surface: '#faf8ff',
        text: '#5a5e68',
        icon: '#8e58ef',
        border: '#bea0f4',
      },
      pressed: {
        surface: '#f4efff',
        text: '#8e58ef',
        icon: '#8e58ef',
        border: '#8e58ef',
      },
      selected: {
        surface: '#f4efff',
        text: '#8e58ef',
        icon: '#8e58ef',
        border: '#8e58ef',
      },
      disabled: {
        surface: '#ffffff',
        text: '#bfbfbf',
        icon: '#bfbfbf',
        border: '#e3e3e3',
      },
    },
    subtle: {
      default: {
        surface: '#ffffff',
        text: '#5a5e68',
        icon: '#5a5e68',
      },
      hover: {
        surface: '#f5f5f5',
        text: '#5a5e68',
        icon: '#5a5e68',
      },
      pressed: {
        surface: '#e3e3e3',
        text: '#5a5e68',
        icon: '#5a5e68',
      },
      focused: {
        surface: '#ffffff',
        text: '#5a5e68',
        icon: '#5a5e68',
        focusRing: '#8e58ef',
      },
      disabled: {
        surface: '#ffffff',
        text: '#bfbfbf',
        icon: '#bfbfbf',
      },
    },
    warning: {
      default: {
        surface: '#fdb022',
        text: '#1e2024',
        icon: '#1e2024',
      },
      hover: {
        surface: '#e69a00',
        text: '#1e2024',
        icon: '#1e2024',
      },
      pressed: {
        surface: '#dc6803',
        text: '#1e2024',
        icon: '#1e2024',
      },
      focused: {
        surface: '#e69a00',
        text: '#1e2024',
        icon: '#1e2024',
        focusRing: '#8e58ef',
      },
      disabled: {
        surface: '#f5f5f5',
        text: '#bfbfbf',
        icon: '#bfbfbf',
      },
    },
    danger: {
      default: {
        surface: '#f44336',
        text: '#ffffff',
        icon: '#ffffff',
      },
      hover: {
        surface: '#d32f2f',
        text: '#ffffff',
        icon: '#ffffff',
      },
      pressed: {
        surface: '#912018',
        text: '#ffffff',
        icon: '#ffffff',
      },
      focused: {
        surface: '#d32f2f',
        text: '#ffffff',
        icon: '#ffffff',
        focusRing: '#8e58ef',
      },
      disabled: {
        surface: '#f5f5f5',
        text: '#bfbfbf',
        icon: '#bfbfbf',
      },
    },
  },
  metric: {
    default: {
      surface: '#ffffff',
      cardTitle: '#5a5e68',
      metric: '#1d1b20',
      border: '#d1d1d1',
    },
    hover: {
      surface: '#f9f7ff',
      cardTitle: '#5a5e68',
      metric: '#1d1b20',
      border: '#8e58ef',
    },
    selected: {
      surface: '#f4efff',
      cardTitle: '#8e58ef',
      metric: '#1d1b20',
      border: '#8e58ef',
    },
    subtle: {
      surface: '#ffffff',
      cardTitle: '#5a5e68',
      metric: '#1d1b20',
      border: '#e3e3e3',
      hoverBorder: '#cccbcb',
    },
  },
  segmentedTabs: {
    track: '#f3f3f3',
    selected: {
      surface: '#ffffff',
      border: '#e5e5e5',
    },
  },
  checkbox: {
    unchecked: {
      surface: '#ffffff',
      border: '#cccbcb',
      hoverSurface: '#f5f5f5',
      hoverBorder: '#b5b3b3',
      disabledSurface: '#e3e3e3',
      disabledBorder: '#cccbcb',
    },
    active: {
      surface: '#8e58ef',
      hoverSurface: '#7946d9',
      disabledSurface: '#cccbcb',
      glyph: '#ffffff',
    },
    focusRing: '#8e58ef',
  },
  /**
   * Five steps from low to high for a street's or property's value on the map.
   * Dark is the low end and pale yellow is the high end. This is the Inferno
   * ramp from the solar output design.
   */
  map: {
    valueScale: ['#000004', '#57106e', '#bc3754', '#f98e09', '#fcffa4'],
  },
  table: {
    header: {
      surface: '#f9fafb',
      border: '#ebf0f3',
      height: 42,
      primaryDotSize: 6,
    },
    /** Dense body row — matches ~48px SaaS tables (Twenty, Xero, Midday). */
    body: {
      height: 48,
    },
  },
} as const;

export type ColorTokens = typeof colorTokens;

export default colorTokens;
